import { InvoiceMergeDataset } from '../../datasets';
import { FakeCompanyMergeData, FakeInvoiceMergeData, FakeBasicSiteMergeData, FakeInvoiceAccountMergeData, FakeActivityMergeData, FakeAttachmentMergeData } from '../data';


export class FakeInvoiceMergeDataset extends InvoiceMergeDataset {

    constructor(baseUrl: string = '') {
        super();

        this.invoice = new FakeInvoiceMergeData();
        this.invoiceCompany = new FakeCompanyMergeData(baseUrl);
        this.invoiceAccountSite = new FakeBasicSiteMergeData();
        this.invoiceAccount = new FakeInvoiceAccountMergeData();
        this.invoiceJobSite = new FakeBasicSiteMergeData();

        this.invoiceActivities = {
            activities: [new FakeActivityMergeData("Contrary to popular belief, <strong>Lorem Ipsum</strong> is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old")],
        }

        this.invoiceAttachment = {
            mediaAttachments: [new FakeAttachmentMergeData("Image", "images/logo-workbuddy.png"), new FakeAttachmentMergeData("Video", "images/logo-workbuddy.png"),],
            fileAttachments: [new FakeAttachmentMergeData("File", "sample file"), new FakeAttachmentMergeData("File", "huy file"),]
        }
    }
}